import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

export const BrandSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        logo: z
            .object({
                fullpath: z.string(),
            })
            .nullable(),
    })
    .describe('BrandSchema');

// Main schema to validate the entire query response
export const GetBrandListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown())
                .transform((brands) => transformAndFilterValidItems(BrandSchema, brands)),
        }),
    })
    .describe('GetBrandListingSchema');
